import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Redirect } from 'react-router-dom';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncSearchResults = Load(
  () =>
    import(
      /* webpackChunkName: "experiences-page" */ './containers/ExperiencesContainer'
    ),
  {},
  true,
);

const ExperiencesRoutes = [
  <NavigationableLayout
    key="experiences"
    path={`${basePath}/experiences*`}
    component={AsyncSearchResults}
    showBottomNavigation
    showSearchInNavbar
  />,
];

const RedirectForApps = (
  <Redirect from={`${basePath}/experiences*`} to={`${basePath}/s*`} />
);

export default isCordova() ? RedirectForApps : ExperiencesRoutes;
